'use client';
import './styles/casino.scss';
import type { Orientation } from '@/types/constants';
import { createImageConfig } from '../../utils/image-config';

type ExclusivePreLaunchBackgroundProps = {
    layoutVariant: Orientation;
    url: string;
};

export const ExclusivePreLaunchBackground: React.FC<ExclusivePreLaunchBackgroundProps> = ({ layoutVariant, url }) => {
    const { src, srcSet, sizes, alt, loading, fetchPriority } = createImageConfig(url, layoutVariant);

    return (
        <div className={`exclusive-pre-launch__background exclusive-pre-launch__background--${layoutVariant}`}>
            <img src={src} srcSet={srcSet} sizes={sizes} alt={alt} loading={loading} fetchPriority={fetchPriority} />
        </div>
    );
};
